module.exports = __webpack_public_path__ + "static/media/stat-pic.75faa8e5.png";